import { render, staticRenderFns } from "./configurationOperations.vue?vue&type=template&id=20aa9672&scoped=true"
import script from "./configurationOperations.vue?vue&type=script&lang=js"
export * from "./configurationOperations.vue?vue&type=script&lang=js"
import style0 from "./configurationOperations.vue?vue&type=style&index=0&id=20aa9672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa9672",
  null
  
)

export default component.exports